/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PersonDocumentType {
  RG = 'RG',
  CNH = 'CNH',
}
